import React, { useState, useEffect, useCallback } from "react";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import Select from "react-select";
import { Row, Col, Badge } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../env";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CroTransferHistoryByMember = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 1000);
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const getMembers = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/getModelData/member_details?fields=id,memberName&filter={"loanType":"Business Loan"}`
      );
      setMembers(
        (response.data.data || []).map((item) => ({
          value: item.id,
          label: item.memberName,
        }))
      );
    } catch (error) {
      console.error("Error fetching members:", error);
      toast.error("Failed to load members");
    }
  }, []);

  useEffect(() => {
    getMembers();
  }, [getMembers]);

  const handleMemberChange = async (selectedOption) => {
    setSelectedMember(selectedOption);
    if (!selectedOption) {
      setHistoryData([]);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/getModelData/member_cro_transfer_history?relationshipType=childToParent&includeDepth=1&filter={"memberId":${selectedOption.value}}`
      );
      setHistoryData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching history:", error);
      toast.error("Failed to load transfer history");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container">
          <div className="master-search-section inline-header">
            <h1 className="TableHeaderText m-0">CRO Transfer History by Member</h1>
          </div>

          {/* Filter Bar */}
          <div className="master-search-section py-3 px-4">
            <Row className="w-100 g-3 align-items-center">
              <Col xs={12} md={6}>
                <label className="form-label fw-semibold text-muted mb-1">
                  Select Member
                </label>
                <Select
                  value={selectedMember}
                  onChange={handleMemberChange}
                  options={members}
                  placeholder="Search and select member..."
                  isClearable
                  className="filter-dropdown"
                />
              </Col>
            </Row>
          </div>

          {/* Table List Section */}
          <div className="master-list-section">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : selectedMember ? (
              <div className="master-table-wrapper table-responsive">
                <table className="mx-auto table table-striped table-list">
                  <thead>
                    <tr>
                      <th style={{ width: "70px" }}>No</th>
                      <th>Member Name</th>
                      <th>Transferred From (CRO)</th>
                      <th>Transferred To (CRO)</th>
                      <th>Transfer Date</th>
                      <th style={{ width: "120px" }}>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {historyData.length > 0 ? (
                      historyData.map((history, index) => (
                        <tr key={history.id || index}>
                          <td>{index + 1}</td>
                          <td className="fw-semibold text-start">
                            {selectedMember.label}
                          </td>
                          <td className="text-primary fw-medium">
                            {
                              history
                                .fk_member_cro_transfer_history_belongsTo_manager_credentials_fromFieldManagerId
                                ?.username || "-"
                            }
                          </td>
                          <td className="text-success fw-medium">
                            {
                              history
                                .fk_member_cro_transfer_history_belongsTo_manager_credentials_toFieldManagerId
                                ?.username || "-"
                            }
                          </td>
                          <td>
                            {history.transferDate
                              ? new Date(history.transferDate).toLocaleDateString(
                                  "en-GB"
                                )
                              : "-"}
                          </td>
                          <td>
                            <Badge bg="success" className="px-2 py-1">
                              Completed
                            </Badge>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-4 text-muted">
                          No transfer history found for this member
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted">
                Please select a member to view their CRO transfer history.
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer position="top-center" />
    </section>
  );
};

export default CroTransferHistoryByMember;
